import { nextTick } from 'process'
import CommonUtil from '@/common/utils/CommonUtil'
import { Component, Vue } from 'vue-property-decorator'
import CACA1070ResponseModel from '@/api/data/CAC/CACA1070/CACA1070ResponseModel'
import CACG1070ViewModel from './CACG1070ViewModel'
import CACG1070Service from './CACG1070Service'
import CACG1060ParamModel from '../CACG1060/CACG1060ParamModel'
import CACG1080ParamModel from '../CACG1080/CACG1080ParamModel'
import TransportService from '@/common/TransportService'
import CommonConstants from '@/common/CommonConstants'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import { FormatConstants } from '@/common/FormatConstants'
import { scrollToDivElement, fixedContent } from '@/assets/js/main.js'

@Component({
  name: 'CACG1070',
  components: {}
  })
export default class CACG1070Controller extends Vue {
  private isCompleteLoading = false
  private FormatConstants = FormatConstants
  private CommonUtil = CommonUtil
  private XSSFilterOptions = XSSFilterOptions
  private MONTHLY = 'monthly'
  private OPERATION = 'operation'
  private isShowMoreOperationReportButton = false
  private maxNumberShowMoreOperationReport = 2
  private titleManual = ''

  private cacg1070ViewModel: CACG1070ViewModel = {
    productNameInformal: '',
    operatProductPdfInfoLst: [],
    operatProductMaterialInfo: {
      operatProductMaterialInfoPdfName: '',
      operatProductMaterialInfoPdfLnkUrl: ''
    },
    operatProductProspectusPdfInfoLst: [],
    operatProductInvestmentRpPdfInfoLst: [],
    productDivName: '',
    productNo: '',
    shhnCd: '',
    isShowMoreMonthlyRpt: false,
    isShowMoreOperationRpt: false
  }

  private caca1070ResponseModel: CACA1070ResponseModel =
    new CACA1070ResponseModel()

  private cacg1070Service: CACG1070Service = new CACG1070Service()
  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    nextTick(() => {
      fixedContent()
    })
  }

  /**
   * 初期処理
   */
  private async init() {
    const productNo = JSON.parse(
      JSON.stringify(this.$route.query.productNo || '')
    )
    const shhnCd = JSON.parse(JSON.stringify(this.$route.query.shhnCd || ''))

    this.cacg1070ViewModel.productNo = productNo
    this.cacg1070ViewModel.shhnCd = shhnCd
    const params = `shhnCd=${this.cacg1070ViewModel.shhnCd}`
    const [
      caca1070ResponseModelResponse,
      transportResponseModel
    ] = await Promise.all([
      this.cacg1070Service.callAPICACA1070(
        productNo,
        shhnCd
      ),
      // 稼働／閲覧統計ログを実行する
      TransportService.callAPITransportWithLogMode(CommonConstants.URL_CACG1070, null, params, CommonConstants.LOG_MODE_ACCESS_ONLY)
    ])
    this.caca1070ResponseModel = caca1070ResponseModelResponse;

    this.cacg1070ViewModel.productNameInformal =
      this.caca1070ResponseModel.productNameInformal

    if (this.caca1070ResponseModel.operatProductPdfInfoLst) {
      this.caca1070ResponseModel.operatProductPdfInfoLst.forEach((item) => {
        if (
          CommonUtil.isNotEmpty(item?.operatProductPdfName) &&
          CommonUtil.isNotEmpty(item?.operatProductPdfLnkUrl)
        ) {
          this.cacg1070ViewModel.operatProductPdfInfoLst.push(item)
        }
      })
    } else {
      this.cacg1070ViewModel.operatProductPdfInfoLst = null
    }

    if (
      CommonUtil.isNotEmpty(
        this.caca1070ResponseModel.operatProductMaterialInfo
      )
    ) {
      this.cacg1070ViewModel.operatProductMaterialInfo =
        this.caca1070ResponseModel.operatProductMaterialInfo
    } else {
      this.cacg1070ViewModel.operatProductMaterialInfo = null
    }

    if (this.caca1070ResponseModel.operatProductProspectusPdfInfoLst) {
      this.caca1070ResponseModel.operatProductProspectusPdfInfoLst.forEach(
        (item) => {
          if (
            CommonUtil.isNotEmpty(item?.operatProductProspectusPdfName) &&
            CommonUtil.isNotEmpty(item?.operatProductProspectusPdfLnkUrl)
          ) {
            this.cacg1070ViewModel.operatProductProspectusPdfInfoLst.push(item)
          }
        }
      )
    } else {
      this.cacg1070ViewModel.operatProductProspectusPdfInfoLst = null
    }

    this.cacg1070ViewModel.productDivName =
      this.caca1070ResponseModel.productDivName

    if (this.caca1070ResponseModel.operatProductInvestmentRpPdfInfoLst) {
      this.caca1070ResponseModel.operatProductInvestmentRpPdfInfoLst.forEach(
        (item) => {
          if (
            CommonUtil.isNotEmpty(item?.operatProductInvestmentRpPdfName) &&
            CommonUtil.isNotEmpty(item?.operatProductInvestmentRpPdfLnkUrl)
          ) {
            this.cacg1070ViewModel.operatProductInvestmentRpPdfInfoLst.push(
              item
            )
          }
        }
      )
      if (
        this.cacg1070ViewModel.operatProductInvestmentRpPdfInfoLst.length > 2
      ) {
        this.isShowMoreOperationReportButton = true
      } else {
        this.maxNumberShowMoreOperationReport = 4
      }
      if (
        this.cacg1070ViewModel.productDivName !== '年金投資基金信託' &&
        window.innerWidth > 896
      ) {
        this.cacg1070ViewModel.operatProductInvestmentRpPdfInfoLst =
          this.cacg1070Service.setPlaceOperationReport(
            this.cacg1070ViewModel.operatProductInvestmentRpPdfInfoLst
          )
      }
    } else {
      this.cacg1070ViewModel.operatProductInvestmentRpPdfInfoLst = null
    }

    this.titleManual =
      this.cacg1070ViewModel.productDivName === '年金投資基金信託'
        ? '信託商品説明書'
        : '投資信託説明書'
    this.isCompleteLoading = true
  }

  /**
   * 「運用商品詳細（投資信託）：基準価額」（CACG1060）画面に遷移する。
   */
  private gotoCACG1060() {
    const cacg1060ParamModel: CACG1060ParamModel = {
      productNo: this.cacg1070ViewModel.productNo,
      shhnCd: this.cacg1070ViewModel.shhnCd
    }
    this.$router.push({ name: 'cacg1060', query: cacg1060ParamModel })
  }

  /**
   * 「運用商品詳細（投資信託）：チャート」（CACG1080）画面に遷移する。
   */
  private gotoCACG1080() {
    const cacg1080ParamModel: CACG1080ParamModel = {
      productNo: this.cacg1070ViewModel.productNo,
      shhnCd: this.cacg1070ViewModel.shhnCd
    }
    this.$router.push({ name: 'cacg1080', query: cacg1080ParamModel })
  }

  /**
   * PDFのURLを別タブで開く。
   * @param pdfFilePath
   */
  private openPDF(pdfFilePath: string) {
    window.open(pdfFilePath, '_blank')
  }

  /**
   * もっと機能を表示
   * @param type
   */
  private changeMoreOrClose(type) {
    if (type === this.MONTHLY) {
      this.cacg1070ViewModel.isShowMoreMonthlyRpt =
        !this.cacg1070ViewModel.isShowMoreMonthlyRpt

      if (!this.cacg1070ViewModel.isShowMoreMonthlyRpt) {
        scrollToDivElement('#product-details-monthly', 0)
      }
    }
    if (type === this.OPERATION) {
      this.cacg1070ViewModel.isShowMoreOperationRpt =
        !this.cacg1070ViewModel.isShowMoreOperationRpt

      if (!this.cacg1070ViewModel.isShowMoreOperationRpt) {
        scrollToDivElement('#product-details-operation', 0)
      }
    }
  }

  /**
   *「運用商品一覧」（CACG1010）画面に遷移する。
   */
  private gotoCACG1010() {
    this.$router.push({ name: 'cacg1010' })
  }
}
